module.exports = __webpack_public_path__ + "24f0a3e055ee1df94f7cf6d9dada00b0.png";